import { RaiaBlack } from '../../assets/raia/black'
import { RaiaBlackSymbol } from '../../assets/raia/black-symbol'
import { RaiaColored } from '../../assets/raia/colored'
import { RaiaColoredSymbol } from '../../assets/raia/colored-symbol'
import { RaiaWhite } from '../../assets/raia/white'
import { RaiaWhiteSymbol } from '../../assets/raia/white-symbol'
import { LogoWhithoutVariant } from '../without-variants'

export const logos = {
  white: {
    large: <RaiaWhite width={102} height={48} />,
    huge: <RaiaWhite width={153} height={64} />,
    enormous: <RaiaWhite width={204} height={80} />,
  },
  black: {
    large: <RaiaBlack width={102} height={48} />,
    huge: <RaiaBlack width={153} height={64} />,
    enormous: <RaiaBlack width={204} height={80} />,
  },
  colored: {
    large: <RaiaColored width={102} height={48} />,
    huge: <RaiaColored width={153} height={64} />,
    enormous: <RaiaColored width={204} height={80} />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}

export const symbols = {
  white: {
    large: <RaiaWhiteSymbol width={32} height={48} />,
    huge: <RaiaWhiteSymbol width={48} height={64} />,
    enormous: <RaiaWhiteSymbol width={64} height={80} />,
  },
  black: {
    large: <RaiaBlackSymbol width={32} height={48} />,
    huge: <RaiaBlackSymbol width={48} height={64} />,
    enormous: <RaiaBlackSymbol width={64} height={80} />,
  },
  colored: {
    large: <RaiaColoredSymbol width={32} height={48} />,
    huge: <RaiaColoredSymbol width={48} height={64} />,
    enormous: <RaiaColoredSymbol width={64} height={80} />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}
